export const pathes = {
  BASE_PATH: '/operating-service',
}

export const billPathes = {
  DEFAULT: '/bill',
  PAST_BILLS: "/bill/past-bills",
  SELECT_NEW_BILL: "/bill/select-new-bill",
  INQUIRY: "/bill/inquiry/:billType",
  SHOW_BILL_INQUIRY: "/bill/show-bill-inquiry",
  PAYMENT: "/bill/payment",
}

export const chargePathes = {
  DEFAULT: '/charge',
}

export const internetPathes = {
  DEFAULT: '/internet',
}